module.exports = __webpack_public_path__ + "img/ow-voices-img.f5378c83.png";